import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import { Forget, Login , Register } from './pages'
import './assets/style/global.css'
import { Base } from './components/widget';
import ContextContainer from './context/ContextContainer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './assets/style/geosearch.css'
import "cropperjs/dist/cropper.css";
import 'leaflet/dist/leaflet.css'


function App() {
  return (
    <ContextContainer>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forget" element={<Forget />} />
          <Route path="/p/*" element={<Base />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer
        position="top-right"
        rtl={true}
        hideProgressBar={false} newestOnTop
        closeOnClick theme='light'
        pauseOnFocusLoss
        draggable pauseOnHover
      />
    </ContextContainer>
  );
}

export default App;
